import { useNavigate } from 'react-router-dom';

export const useDashboardOnClickHandler = () => {
  const navigate = useNavigate();

  const handleFieldClick = (sectionKey, fieldKey, resetFilters = false, date = null) => {
    if (sectionKey === 'oferenci_successful') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      }
      
      if (fieldKey === 'nwu') {
        params.set('is_nwu', 'true');
      } else if (fieldKey === 'wadia') {
        params.set('is_wadium', 'true');
      }
      
      navigate(`/bidders/successful?${params.toString()}`);
    } else if (sectionKey === 'oferenci_leady') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      }
      
      if (fieldKey === 'nwu') {
        params.set('is_nwu', 'true');
      } else if (fieldKey === 'wadia') {
        params.set('is_wadium', 'true');
      }
      
      navigate(`/bidders/leads?${params.toString()}`);
    } else if (sectionKey === 'oferenci_errors') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      } else {
        const filter = {};
        if (fieldKey === 'brak_nip') {
          filter.error_message = 'numeru NIP';
        } else if (fieldKey === 'brak_email') {
          filter.error_message = 'Brak adresu email';
        } else if (fieldKey === 'brak_pwg') {
          filter.missing_pwg = true;
        }
        if (date) {
          filter.updated_at_gte = `${date}T00:00:00`;
          filter.updated_at_lte = `${date}T23:59:59`;
        }
        if (Object.keys(filter).length > 0) {
          params.set('filter', JSON.stringify(filter));
        }
      }

      navigate(`/workflow/failed-bidder-workflows?${params.toString()}`);
    } else if (sectionKey === 'zamowienia_downloaded') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      }
      
      if (fieldKey === 'nwu') {
        params.set('is_nwu', 'true');
      } else if (fieldKey === 'wadia') {
        params.set('is_wadium', 'true');
      }
      
      navigate(`/tenders/processed?${params.toString()}`);
    } else if (sectionKey === 'zamowienia_errors') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      }
      
      if (fieldKey === 'nwu') {
        params.set('is_nwu', 'true');
      } else if (fieldKey === 'wadia') {
        params.set('is_wadium', 'true');
      }
      
      navigate(`/tenders/failed?${params.toString()}`);
    } else if (sectionKey === 'zamowienia_archived') {
      const params = new URLSearchParams();
      if (resetFilters) {
        params.set('filter', JSON.stringify({}));
      }
      
      if (fieldKey === 'nwu') {
        params.set('is_nwu', 'true');
      } else if (fieldKey === 'wadia') {
        params.set('is_wadium', 'true');
      }
      
      navigate(`/tenders/archived?${params.toString()}`);
    }
  };

  return { handleFieldClick };
};

